module.exports = __webpack_public_path__ + "img/mobileapplication3.3762b497.png";